import { Box, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import React from "react";

function Header() {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 4,
        }}
      >
        <Box
          component="img"
          sx={{
            display: "block",
            maxWidth: "230px",
            maxHeight: "100px",
            width: "auto",
            height: "auto",
          }}
          alt="L3 logo"
          src="./l3.png"
        />
        <Box
          component="img"
          sx={{
            display: "block",
            maxWidth: "180px",
            maxHeight: "60px",
            width: "auto",
            height: "auto",
          }}
          alt="AHS logo"
          src="./ahs.png"
        />
      </Box>
      <Box sx={{ mb: 5 }}>
        <Typography variant="h6" align="center" gutterBottom>
          Heart Failure Disease Care Path Integration- Evidence-based Guideline
          Recommended Best Care
        </Typography>
        <Alert severity="info">
          An updated version of this course will be available at 16:00 MST on
          December 23, 2025. The HF content will not change, there will just be
          an update of the CFPC course ID renewal. Consider waiting for the next
          session opening if you cannot complete the course prior to the end of
          the current session – 16:00 MST December 23, 2025.
        </Alert>
        <Typography
          variant="h6"
          align="center"
          color="textSecondary"
          sx={{ fontSize: 16, fontWeight: 400, mt: 2 }}
        >
          To enroll in this course, please fill out the following information
        </Typography>
      </Box>
    </Box>
  );
}

export default Header;
